import { setupFormState } from '@/components/form/tidal-form'
import { BulkDriverFormValues } from './types'

export const defaultInitialValues: BulkDriverFormValues = {
  summarizeFutureMobileRoute: { status: 'mixed' },
  mobileFutureDaysVisibility: { status: 'mixed' },
}

export const form = setupFormState<BulkDriverFormValues>({
  id: 'bulkDriverForm',
  initialValues: defaultInitialValues,
})
